import { createFileRoute } from '@tanstack/react-router';

import { RoutePlaceholder } from '@/components/app/RoutePlaceholder';

export const Route = createFileRoute('/find-and-fix/poi/$poiId/recheck')({
    component: PoiRecheck,
});

function PoiRecheck() {
    const { poiId } = Route.useParams();
    return <RoutePlaceholder title={`Find & Fix — POI ${poiId} — Recheck`} />;
}
